var SCM = SCM || {};

SCM.UIFeedback = (function () {
    
    function create(options) {
        const _options = _mergeOptions(options);
        const _logger = (SCM.DebugLogger && SCM.DebugLogger.create) 
            ? SCM.DebugLogger.create('UIFeedback', { debugMode: _options.debugMode || false })
            : { debug: function(){}, info: function(){}, warn: function(){}, error: function(){} };
        const _state = {
            interactiveElements: [],
            currentHover: null,
            currentSelected: null,
            currentError: null
        };
        
        function makeInteractive(element) {
            if (!_validateElement(element, 'makeInteractive')) {
                return;
            }
            
            if (_state.interactiveElements.indexOf(element) !== -1) {
                _logger.debug('Element already interactive', { element: element });
                return;
            }
            
            try {
                _addClass(element, _options.classes.interactive);
                _setupEventListeners(element);
                _state.interactiveElements.push(element);
                _logger.debug('Element made interactive', { element: element });
            } catch (error) {
                _logger.error('Failed to make element interactive', { error: error.message });
            }
        }
        
        function setSelected(element) {
            if (!_validateElement(element, 'setSelected')) {
                return;
            }
            
            clearAll();
            
            try {
                _addClass(element, _options.classes.selected);
                _state.currentSelected = element;
                _logger.debug('Element set to selected state', { element: element });
            } catch (error) {
                _logger.error('Failed to set selected state', { error: error.message });
            }
        }
        
        function setHover(element) {
            if (!_validateElement(element, 'setHover')) {
                return;
            }
            
            if (_state.currentSelected === element) {
                return;
            }
            
            _clearHover();
            
            try {
                _addClass(element, _options.classes.hover);
                _state.currentHover = element;
                _logger.debug('Element set to hover state', { element: element });
            } catch (error) {
                _logger.error('Failed to set hover state', { error: error.message });
            }
        }
        
        function setError(element) {
            if (!_validateElement(element, 'setError')) {
                return;
            }
            
            try {
                _addClass(element, _options.classes.error);
                _state.currentError = element;
                _logger.debug('Element set to error state', { element: element });
            } catch (error) {
                _logger.error('Failed to set error state', { error: error.message });
            }
        }
        
        function clearAll() {
            _clearSelected();
            _clearHover();
            _clearError();
            _logger.debug('All states cleared');
        }
        
        function _setupEventListeners(element) {
            if (!_options.touch.enabled) {
                return;
            }
            
            const clickHandler = function(event) {
                _handleInteraction(element, event);
            };
            
            const hoverInHandler = function() {
                setHover(element);
            };
            
            const hoverOutHandler = function() {
                if (_state.currentHover === element) {
                    _clearHover();
                }
            };
            
            if (_isTouchDevice()) {
                element.addEventListener('touchstart', clickHandler, { passive: false });
                element.addEventListener('touchend', function(event) {
                    if (_options.touch.preventDefault) {
                        event.preventDefault();
                    }
                }, { passive: false });
            } else {
                element.addEventListener('click', clickHandler);
                element.addEventListener('mouseenter', hoverInHandler);
                element.addEventListener('mouseleave', hoverOutHandler);
            }
        }
        
        function _handleInteraction(element, event) {
            if (_options.touch.preventDefault && event.type.indexOf('touch') === 0) {
                event.preventDefault();
            }
            
            _logger.debug('Element interaction detected', { 
                element: element, 
                eventType: event.type 
            });
        }
        
        function _isTouchDevice() {
            return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        }
        
        function _validateElement(element, methodName) {
            if (!element || !element.nodeType) {
                _logger.error('Invalid element provided to ' + methodName);
                return false;
            }
            
            if (!_validateCSSClasses()) {
                _logger.error('Invalid CSS class configuration');
                return false;
            }
            
            return true;
        }
        
        function _validateCSSClasses() {
            return _options.classes.interactive && 
                   _options.classes.hover && 
                   _options.classes.selected && 
                   _options.classes.error;
        }
        
        function _addClass(element, className) {
            if (!className) {
                throw new Error('Invalid CSS class name');
            }
            
            if (!element.classList) {
                throw new Error('Element does not support classList API');
            }
            
            element.classList.add(className);
        }
        
        function _removeClass(element, className) {
            if (element && element.classList && className) {
                element.classList.remove(className);
            }
        }
        
        function _clearSelected() {
            if (_state.currentSelected) {
                _removeClass(_state.currentSelected, _options.classes.selected);
                _state.currentSelected = null;
            }
        }
        
        function _clearHover() {
            if (_state.currentHover) {
                _removeClass(_state.currentHover, _options.classes.hover);
                _state.currentHover = null;
            }
        }
        
        function _clearError() {
            if (_state.currentError) {
                _removeClass(_state.currentError, _options.classes.error);
                _state.currentError = null;
            }
        }
        
        return {
            makeInteractive: makeInteractive,
            setSelected: setSelected,
            setHover: setHover,
            setError: setError,
            clearAll: clearAll
        };
    }
    
    function _mergeOptions(options) {
        const defaults = {
            classes: {
                interactive: 'sb-widget-interactive',
                hover: 'sb-widget-hover',
                selected: 'sb-widget-selected',
                error: 'sb-widget-error'
            },
            touch: {
                enabled: true,
                preventDefault: true
            }
        };
        
        if (!options) {
            return defaults;
        }
        
        return {
            classes: { ...defaults.classes, ...(options.classes || {}) },
            touch: { ...defaults.touch, ...(options.touch || {}) }
        };
    }
    
    return {
        create: create
    };
    
})();

'object' === typeof module && module.exports && (module.exports = SCM.UIFeedback);